import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import {StatementsComponent} from "./statements.component";
import {PipesModule} from "../../pipes/pipes.module";

@NgModule({
    entryComponents: [
    ],
    imports: [
        CommonModule,
        PipesModule,
    ],
    exports:[
        StatementsComponent
    ],
    declarations: [
        StatementsComponent
    ],
    providers: [

    ]
})

export class StatementsModule {

}



// WEBPACK FOOTER //
// ./src/app/modules/statements/statements.module.ts